import { render } from "./EntrepreneurInfo.vue?vue&type=template&id=e9d8efd4&scoped=true"
import script from "./EntrepreneurInfo.vue?vue&type=script&lang=js"
export * from "./EntrepreneurInfo.vue?vue&type=script&lang=js"

import "./EntrepreneurInfo.vue?vue&type=style&index=0&id=e9d8efd4&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9d8efd4"]])

export default __exports__